// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZhihuCircleFilledSvg from "@fishx/icons-svg/es/asn/ZhihuCircleFilled";
import FishxIcon from '../components/FishxIcon';

var ZhihuCircleFilled = function ZhihuCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuCircleFilledSvg
  }));
};

ZhihuCircleFilled.displayName = 'ZhihuCircleFilled';
export default React.forwardRef(ZhihuCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ZhihuCircleFilled.js
// module id = 4430
// module chunks = 0